import { StarIcon } from "@heroicons/react/24/solid";
import { memo } from "react";
import classNames from "src/helpers/classNames";

type Props = {
	rating: number;
	starClassName?: string;
};

function Stars({ rating, starClassName = "text-beige-900" }: Props) {
	return (
		<div className="flex items-center">
			{Array.from(Array(rating).keys()).map((item) => (
				<StarIcon
					key={item}
					className={classNames("flex-shrink-0", starClassName)}
					aria-hidden="true"
				/>
			))}
		</div>
	);
}

export default memo(Stars);
